import GeoreferenziazioniTable from './GeoreferenziazioniTable';
export default GeoreferenziazioniTable;